// extracted by mini-css-extract-plugin
module.exports = {"logos__list":"LogosListSection_logos__list__86G9_","logosContainer":"LogosListSection_logosContainer__5HdoF"};